import * as _ from 'lodash';
import { action, observable, runInAction } from 'mobx';
import { DefaultAffinityCluster, IAffinityCluster } from 'src/Definitions';
import {
    AffinityClusterDto,
    Client,
    IAffinityClusterDto,
    SwaggerResponse,
} from 'src/generated_client';
import DataTableStore from '../DataTableStore';

export default class AffinityClustersStore {
    @observable
    public isDeleteModalOpen: boolean;
    @observable
    public isLoading: boolean = false;
    @observable
    public isModalOpen: boolean;
    @observable
    public affinityClusters: IAffinityCluster[];
    @observable
    public selectedAffinityCluster?: IAffinityCluster;
    public dataTableStore: DataTableStore<IAffinityClusterDto, IAffinityCluster>;

    constructor(private client: Client) {}

    @action.bound
    public closeDeleteDialog() {
        this.isDeleteModalOpen = false;
        this.selectedAffinityCluster = undefined;
    }

    @action.bound
    public closeDialog() {
        this.isModalOpen = false;
        this.selectedAffinityCluster = undefined;
    }

    @action.bound
    public disableAffinityCluster(affinityCluster: IAffinityCluster) {
        this.isLoading = true;
        return this.client
            .archiveAffinityCluster(affinityCluster.id)
            .then(() => this.dataTableStore.loadData())
            .catch(() => {})
            .finally(() =>
                runInAction(() => {
                    this.isLoading = false;
                })
            );
    }

    @action.bound
    public getAllAffinityClusters(assessmentId: string) {
        this.isLoading = true;
        return this.client
            .getAllAffinityClusters(assessmentId, 1, 2000)
            .then((resp: SwaggerResponse<IAffinityClusterDto[]>) =>
                runInAction(() => {
                    this.affinityClusters = this.setupAffinityClusters(resp.result);
                })
            )
            .catch(() => {})
            .finally(() =>
                runInAction(() => {
                    this.isLoading = false;
                })
            );
    }

    @action.bound
    public openDeleteDialog(affinityCluster: IAffinityCluster) {
        this.isDeleteModalOpen = true;
        this.selectedAffinityCluster = affinityCluster;
    }

    @action.bound
    public openDialogWithAffinityCluster(affinityCluster: IAffinityCluster) {
        this.isModalOpen = true;
        this.selectedAffinityCluster = affinityCluster;
    }

    @action.bound
    public recoverAffinityCluster(affinityCluster: IAffinityCluster) {
        this.isLoading = true;
        return this.client
            .reactivateAffinityCluster(affinityCluster.id)
            .then(() => this.dataTableStore.loadData())
            .catch(() => {})
            .finally(() => {
                runInAction(() => {
                    this.isLoading = false;
                });
            });
    }

    private resetUIState(shouldClearFilter: boolean) {
        if (shouldClearFilter) {
            this.dataTableStore.clearFilter();
        }
        this.dataTableStore.loadData();
        this.closeDialog();
    }

    @action.bound
    public saveAffinityCluster(affinityCluster: IAffinityCluster) {
        this.isLoading = true;
        let promise;
        const affinityClusterDto = new AffinityClusterDto(affinityCluster);
        if (affinityCluster.isNew) {
            promise = this.client.createAffinityCluster(affinityClusterDto);
        } else {
            promise = this.client.updateAffinityCluster(affinityCluster.id, affinityClusterDto);
        }
        return promise
            .then(() => {
                this.resetUIState(affinityCluster.isNew);
            })
            .catch(() => {})
            .finally(() =>
                runInAction(() => {
                    this.isLoading = false;
                    this.isModalOpen = false;
                })
            );
    }

    private setupAffinityClusters = (affinityClusters: IAffinityClusterDto[]) => {
        return affinityClusters.map((x) => this.addDefaultFields(x));
    };

    private addDefaultFields = (affinityCluster: IAffinityClusterDto): IAffinityCluster => {
        return { ...DefaultAffinityCluster(), ...affinityCluster };
    };
}



// WEBPACK FOOTER //
// ./src/stores/AffinityClustersStore/AffinityClustersStore.ts